// btw-front/src/components/sections/TrustBar.jsx
import React, { useMemo } from "react";
import Container from "../ui/Container";
import { useTranslation } from "react-i18next";

export default function TrustBar() {
  const { t } = useTranslation();
  const items = useMemo(() => t("trustbar.items", { returnObjects: true }) || [], [t]);

  return (
    <section
      aria-label={t("trustbar.flagshipLabel")}
      className="border-y border-slate-200 bg-gradient-to-r from-slate-100 via-white to-slate-100"
    >
      <Container>
        <div className="space-y-3 py-6">
          {/* Row 1: Flagship — CertBear */}
          <a href="#certbear" className="group flex flex-wrap items-center gap-3">
            <span className="inline-flex items-center rounded-full bg-accent px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-white">
              {t("trustbar.flagshipLabel")}
            </span>
            <span className="relative inline-block text-base font-bold text-slate-900 transition-colors group-hover:text-accent after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:origin-left after:scale-x-0 after:bg-accent after:transition-transform after:duration-500 group-hover:after:scale-x-100 motion-reduce:after:hidden">
              {t("trustbar.flagshipName")}
            </span>
            <span className="hidden text-sm text-slate-600 sm:inline">
              — {t("trustbar.flagshipDesc")}
            </span>
            <span
              aria-hidden="true"
              className="ml-auto text-xs text-slate-400 transition-colors group-hover:text-accent"
            >
              →
            </span>
          </a>

          {/* Row 2: Supporting (partner · coverage · tagline) */}
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div className="flex items-center gap-2 text-sm font-medium text-slate-700">
              <span className="inline-block h-2 w-2 rounded-full bg-emerald-500" />
              {t("trustbar.partner")}
            </div>

            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs text-slate-500">{t("trustbar.coverage")}</span>
              {items.map((it) => (
                <span key={it} className="btw-chip">
                  {it}
                </span>
              ))}
            </div>

            <div className="text-xs text-slate-500">{t("trustbar.tagline")}</div>
          </div>
        </div>
      </Container>
    </section>
  );
}
